import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstPlanillaRecorrido = () => import('./Index')
const ViewMapaPr = () => import('./Modulos_Planillas/MapaPrPage.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_planilla_campo',
        name: 'lst_planilla_recorrido',
        component: ViewLstPlanillaRecorrido,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'mapa_planilla_recorrido',
        name: 'mapa_planilla_recorrido',
        component: ViewMapaPr,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router